import { CardPermissionFlags, CardSectionPermissionInfo, CardStoreMode } from "tessa/cards";
import { CdDocStates } from "./CdDocStates";
import { CdCardTypes } from "./CdCardTypes";
import { tryGetFromInfo } from "tessa/ui";
import { CdCardFlagsInfo } from "./CdCardFlagsInfo";

export class CdCardHelper {

  public static CanEnableActionTile(model, card): boolean {
      return CdCardHelper.CanStartExecutionProcess(model, card) ||
             CdCardHelper.CanChangeStateToIrrelevant(model, card) ||
             CdCardHelper.CanStartCreateBasedDocument(model, card) ||
             (tryGetFromInfo(card.info, CdCardFlagsInfo.PkExecutionTaskFlag, false) ||
             tryGetFromInfo(card.info, CdCardFlagsInfo.PkAcquaintanceTaskFlag, false) ||
             tryGetFromInfo(card.info, CdCardFlagsInfo.PkNotRelevantFlag, false) ||
             tryGetFromInfo(card.info, CdCardFlagsInfo.PkCreateChangesOrdFlag, false) ||
             tryGetFromInfo(card.info, CdCardFlagsInfo.PkRecallForRevisionFlag, false) ||
             tryGetFromInfo(card.info, CdCardFlagsInfo.PkCreatedBasedFlag, false) ||
             tryGetFromInfo(card.info, CdCardFlagsInfo.PkCopyCardFlag, false) ||
             tryGetFromInfo(card.info, CdCardFlagsInfo.PkEditRegistrationNumberFlag, false) ||
             tryGetFromInfo(card.info, CdCardFlagsInfo.PkCanMergeDuplicatesIDP, false)) ||
             CdCardHelper.CheckSkp(model) ||
             CdCardHelper.CanAddToFavorites(model, card) ||
             CdCardHelper.CanRemoveToFavorites(model, card) ||
             CdCardHelper.CanCopyCard(model, card) ||
             CdCardHelper.CanStartSearchFileFromCards(model, card);
  }

  public static CanStartExecutionProcess(model, card): boolean {
      return card.storeMode === CardStoreMode.Update
              && (model.cardType.id === CdCardTypes.TechnicalDocumentationTypeID
                 && tryGetFromInfo(card.info, "CanStartExecutionProcess", false)
              || CdCardTypes.TileExecutionAcquaintanceCardTypes.indexOf(model.cardType.id) > -1);
  }

  public static CanStartAcquaintanceProcess(model, card): boolean {
    return card.storeMode === CardStoreMode.Update
            && (model.cardType.id === CdCardTypes.TechnicalDocumentationTypeID
               && tryGetFromInfo(card.info, "CardStartAcquaintanceProcess", false)
            || CdCardTypes.TileExecutionAcquaintanceCardTypes.indexOf(model.cardType.id) > -1);
  }

  public static CanChangeStateToIrrelevant(model, card): boolean {
      return card.storeMode === CardStoreMode.Update
             && (model.cardType.id === CdCardTypes.TechnicalDocumentationTypeID
                 && tryGetFromInfo(card.info, "CanChangeStateToIrrelevant", false));
  }

  public static CanStartCreateBasedDocument(model, card): boolean {
      return card.storeMode === CardStoreMode.Update
             && (model.cardType.id === CdCardTypes.PkProtocolTenderTypeID
                 && CdCardHelper.isRejected(card));
  }


  public static isRejected(card: any): boolean {
    let visible = false;
    let section;
    let filed;
    if ((section = card.sections.tryGet('PkDocumentCommonInfo')) != null) {
      if (section.fields.tryGet("StateID") != null) {
        if ((filed = section.fields.tryGet("StateID")) != null) {
          if (filed === CdDocStates.Rejected.id) {
            visible = true;
          }
        }
      }
    }
    return visible;
  }

  public static CheckSkp (model): boolean {
    let result = false;
    let section;
    let filed;
    if (model != null && model.card != null) {
      if ((section = model.card.sections.tryGet('PkDocumentCommonInfo')) != null) {
        if (section.fields.tryGet("DVID") != null) {
          if ((filed = section.fields.tryGet("ArStateID")) != null) {
            if (filed !== CdDocStates.Complete.id) {
              result = true;
            }
          }
        }
      }
    }
    return result;
  }

  public static CanAddToFavorites(model, card): boolean {
      return card.storeMode === CardStoreMode.Update
             && model.cardType.id === CdCardTypes.TechnicalDocumentationTypeID
             && tryGetFromInfo(card.info, "CanAddToFavorites", false)
             && !tryGetFromInfo(card.info, "DocumentIsInFavorites", false);
  }

  public static  CanRemoveToFavorites(model, card): boolean {
    return card.storeMode === CardStoreMode.Update
           && model.cardType.id === CdCardTypes.TechnicalDocumentationTypeID
           && tryGetFromInfo(card.info, "CanAddToFavorites", false)
           && tryGetFromInfo(card.info, "DocumentIsInFavorites", false);
  }

  public static CanCopyCard(model, card): boolean {
      return card.storeMode === CardStoreMode.Update
             && model.cardType.id === CdCardTypes.TechnicalDocumentationTypeID
             && tryGetFromInfo(card.info, "CanCopyCard", false);
  }

  public static CanStartSearchFileFromCards(model, card): boolean {
      return card.storeMode === CardStoreMode.Update
             && model.cardType.id === CdCardTypes.PkExecutiveDocumentationTypeID;
  }

  /** Проверка прав на доступность поля для изменения в секции. */
  public static IsFieldAllowModify(
    cardSectionPermissionInfo: CardSectionPermissionInfo | undefined,
    fieldName: string) {
    // проверяем задана ли секция прав
    if (cardSectionPermissionInfo == null){
      return true;
    }

    // получаем права на поле
    const fieldPermissions = cardSectionPermissionInfo.fieldPermissions.tryGet(fieldName);

    // если заданы права на поле
    if (fieldPermissions != null) {
      // возвращаем доступность прав на поле
      return fieldPermissions.$value == CardPermissionFlags.AllowModify;
    }

    // иначе возвращаем доступность прав на секцию
    return cardSectionPermissionInfo.sectionPermissions == CardPermissionFlags.AllowModify;
  }
}